import moment from 'moment';
moment.locale('pt-br');

const formatWithDay = date => {
    const dateParts = moment(parseInt(date)).format('DD/MM/YYYY, dddd').split(', ');
    const dayDescription = dateParts[1].charAt(0).toUpperCase() + dateParts[1].slice(1);

    return `${dateParts[0]}, ${dayDescription}`;
}

export {
  formatWithDay,
}